import { SVGProps } from "react";

const QuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10.3333"
      cy="10.0003"
      r="8.33331"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3337 11.667V11.4337C10.3337 10.6781 10.7554 10.2781 11.1771 9.9559C11.5887 9.64479 12.0003 9.2448 12.0003 8.51147C12.0003 7.48925 11.2574 6.66699 10.3337 6.66699C9.40995 6.66699 8.66699 7.48925 8.66699 8.51147"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3258 13.3333H10.3408"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default QuestionCircle;
